import { useEffect, useState } from "react";
import useSyncStore from "@/stores/sync";

export const AppDataLoader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        console.log("Fetching application shell...");
        await useSyncStore.getState().fetchSnapshot();
        console.log("Shell received, application hydrated.");
        
        // The fetchSnapshot function now hydrates shell stores and initializes
        // the sync store with the correct revision number from the shell.
        // We don't need to call init() here anymore as it's part of fetchSnapshot.
      } catch (err: any) {
        console.error("Failed to initialize app state:", err);
        setError("Could not connect to the server. Please check your connection and refresh.");
      } finally {
        setLoading(false);
      }
    };

    initializeApp();
  }, []);

  if (loading) {
    return <div className="flex h-screen w-full items-center justify-center">Loading workspace...</div>;
  }

  if (error) {
      return <div className="flex h-screen w-full items-center justify-center p-8 text-center text-destructive">{error}</div>;
  }

  return <>{children}</>;
};